import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { preloadAdminAnnouncementBanner } from '@confluence/admin-announcement-banner/entry-points/preloadAdminAnnouncementBanner';
import { preloadStorageEnforcementBanner } from '@confluence/storage-enforcement/entry-points/preloadStorageEnforcementBanner';

export const preloadBanners = async () => {
	const { edition } = getPreloaderFnContext();

	const upperCaseEdition = edition?.toUpperCase() || '';
	if (upperCaseEdition === 'PREMIUM' || upperCaseEdition === 'STANDARD') {
		return preloadAdminAnnouncementBanner();
	} else if (upperCaseEdition === 'FREE') {
		return preloadStorageEnforcementBanner();
	}
};
